import { useTranslation } from 'react-i18next'

import { Tab } from 'components/Tabs'
import { ModulesCommonTabs } from 'features/globalSetup'
import { GeneralTab } from '../../tabs/GeneralTab'
import { InventoryConnectionTab } from '../../tabs/InventoryConnectionTab'

export const useTabs = (): Tab<ModulesCommonTabs>[] => {
  const { t } = useTranslation('features/globalSetup', {
    keyPrefix: 'prebid.modules.general.edit.tabs',
  })

  return [
    {
      element: 'general',
      label: t('general'),
      page: <GeneralTab />,
    },
    {
      element: 'inventory-connection',
      label: t('inventoryConnection'),
      page: <InventoryConnectionTab />,
    },
  ]
}
